<ion-content *ngIf="!error" class="content" slp-ionic-platform>
  <b>{{ "administration.hierarchy.orgHierarchy" | translate }}</b>

  <ion-item lines="none" [class.errorMessage]="hasNoSelection" [class.message]="!hasNoSelection">
    <ion-text *ngIf="hasNoSelection">{{ "administration.hierarchy.messageAtLeastOneProgramOrLocation" | translate }}
    </ion-text>
  </ion-item>

  <ion-item lines="none">
    <ion-checkbox name="full-hierarchy" class="full-hierarchy-checkbox" [disabled]="readonly"
      [ngModel]="userHierarchy.isAssignedFullHierarchy" (ionChange)="toggleAssignedFullHierarchy($event)"
      aria-label=""></ion-checkbox>
    <ion-label for="full-hierarchy" class="checkbox-label">{{
      "administration.hierarchy.fullHierarchy" | translate
      }}</ion-label>
  </ion-item>
  <ion-accordion-group>
    <ion-accordion *ngFor="let enterprise of userHierarchy.listEnterprise; let enterpriseIndex = index">
      <ion-item slot="header">
        <ion-icon slot="start" name="chevron-up-outline" class="ion-accordion-toggle-icon"></ion-icon>
        <ion-label appClickNoPropagate class="toggle-label">{{enterprise.name}}</ion-label>
        <ion-toggle appClickNoPropagate slot="end" color="primary" class="parent-toggle" aria-label=""
          [disabled]="readonly || userHierarchy.isAssignedFullHierarchy" [ngModel]="enterprise.isSelected"
          (ionChange)="toggleEnterprise(enterprise, $event)"></ion-toggle>
      </ion-item>
      <ion-list class="programLocationSection" slot="content">
        <ion-segment (ionChange)="segmentChanged($event,enterpriseIndex)" value="programs" color="tertiary">
          <ion-segment-button value="programs">
            <span>
              <ion-label class="segment-label">{{ "administration.hierarchy.programs" | translate }}</ion-label>
              {{ "administration.hierarchy.selectedPrograms" | translate: { selectedPrograms:
              getSelectedProgramGroups(enterprise), totalPrograms: getTotalProgramGroups(enterprise) } }}
            </span>
          </ion-segment-button>
          <ion-segment-button value="locations">
            <span>
              <ion-label class="segment-label">{{ "administration.hierarchy.locations" | translate }}</ion-label>
              {{ "administration.hierarchy.selectedLocations" | translate: { selectedLocations:
              getSelectedMerchants(enterprise), totalLocations: getTotalMerchants(enterprise) } }}
            </span>
          </ion-segment-button>
        </ion-segment>
        <ng-container *ngIf="segmentValues[enterpriseIndex] === 'programs'">
          <ion-item *ngFor="let program of enterprise.programGroups">
            <ion-label class="toggle-label">{{program.code + ' - ' + program.description}}</ion-label>
            <ion-toggle slot="end" class="child-toggle" color="tertiary" aria-label=""
              [disabled]="readonly || userHierarchy.isAssignedFullHierarchy" [ngModel]="program.isSelected"
              (ionChange)="togglePrograms(enterprise, program, $event)"></ion-toggle>
          </ion-item>
        </ng-container>
        <ng-container *ngIf="segmentValues[enterpriseIndex] === 'locations'">
          <ion-item *ngFor="let merchant of enterprise.merchants">
            <ion-label class="toggle-label">{{merchant.name}}</ion-label>
            <ion-toggle slot="end" class="child-toggle" color="tertiary" aria-label=""
              [disabled]="readonly || userHierarchy.isAssignedFullHierarchy" [ngModel]="merchant.isSelected"
              (ionChange)="toggleMerchants(enterprise, merchant, $event)"></ion-toggle>
          </ion-item>
        </ng-container>
      </ion-list>
    </ion-accordion>
  </ion-accordion-group>
</ion-content>
<div *ngIf="error" class="ion-text-center error-load">
  <h5>{{ "administration.InternalError" | translate }}</h5>
</div>